/**
 * Canonical student profile completeness catalog (pure).
 * Must stay in sync with backend/src/domain/studentCompleteness/profileCompletenessFields.js
 */

export const CATEGORY_LABELS = {
  identity: 'Identity',
  contact: 'Contact',
  location: 'Location',
  parents: 'Parents',
  profile: 'Profile',
  enrollment: 'Enrollment',
  academics: 'Academics',
};

export const PROFILE_COMPLETENESS_FIELDS = [
  { key: 'id', label: 'VE Student ID', category: 'identity' },
  { key: 'fullName', label: 'Full name', category: 'identity' },
  { key: 'emailAddress', label: 'Email', category: 'identity' },
  { key: 'phoneNumber', label: 'Phone', category: 'identity' },
  { key: 'gender', label: 'Gender', category: 'identity' },

  { key: 'currentAddress', label: 'Current address', category: 'contact' },
  { key: 'permanentAddress', label: 'Permanent address', category: 'contact' },
  { key: 'currentLocation', label: 'Current location', category: 'contact' },
  { key: 'pincode', label: 'Pincode', category: 'contact' },
  { key: 'dob', label: 'Date of birth', category: 'contact' },

  { key: 'countryId', label: 'Country', category: 'location' },
  { key: 'stateId', label: 'State', category: 'location' },
  { key: 'cityId', label: 'City', category: 'location' },

  { key: 'parentsName', label: 'Parents name', category: 'parents' },
  { key: 'parentsPhone', label: 'Parents phone', category: 'parents' },
  { key: 'parentsEmail', label: 'Parents email', category: 'parents' },

  { key: 'domainId', label: 'Domain', category: 'profile' },
  { key: 'profilePreference', label: 'Profile preference', category: 'profile' },
  { key: 'heardFromId', label: 'Heard from', category: 'profile' },
  { key: 'joiningKitReceived', label: 'Joining kit received', category: 'profile' },
  { key: 'linkedIn', label: 'LinkedIn', category: 'profile' },

  { key: 'enrollment', label: 'Enrollment / batch', category: 'enrollment' },
  { key: 'enrollmentCourse', label: 'Course', category: 'enrollment' },
  { key: 'enrollmentMode', label: 'Mode', category: 'enrollment' },

  { key: 'highestDegree', label: 'Highest degree', category: 'academics' },
  {
    key: 'highestDegreeUniversity',
    label: 'Highest degree university/college',
    category: 'academics',
  },
  {
    key: 'highestDegreeYear',
    label: 'Highest degree year of passout',
    category: 'academics',
  },
  {
    key: 'highestDegreePercentage',
    label: 'Highest degree %/CGPA',
    category: 'academics',
  },
];

export function completenessStudentQueueId(studentId) {
  return `completeness:${studentId}`;
}

export function parseCompletenessStudentId(queueId) {
  if (!String(queueId || '').startsWith('completeness:')) return null;
  return String(queueId).slice('completeness:'.length);
}

/**
 * Shape a completeness API student into the staging edit-panel document.
 */
export function mapCompletenessStudentToQueueItem(student) {
  if (!student) return null;
  const missingKeys = student.missingKeys || [];
  return {
    id: completenessStudentQueueId(student.id),
    emailKey: student.emailAddress || '',
    status: student.complete ? 'applied' : 'applied_partial',
    source: 'completeness',
    ruleResult: {
      matchStatus: 'existing',
      matchedStudentId: student.id,
      email: student.emailAddress || '',
      firstName: String(student.fullName || '').split(/\s+/)[0] || '',
      lastName: String(student.fullName || '').split(/\s+/).slice(1).join(' '),
      reviewReasons: missingKeys,
      needsReview: !student.complete,
      emailOccurrenceCount: 1,
    },
  };
}
